import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@wyocspay/ui/tokens.css';
import { App } from './App.js';
import { SubscriptionPay } from './SubscriptionPay.js';

// A merchant paying for a fee-waiver package arrives at /s/<token>; everything
// else is the customer checkout. Chosen here so the two flows share nothing but
// the origin - the subscription page never mounts the customer app's machinery.
const subMatch = /^\/s\/([A-Za-z0-9_-]{20,})/.exec(window.location.pathname);

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    {subMatch ? <SubscriptionPay token={subMatch[1]} /> : <App />}
  </StrictMode>,
);
